import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import FinanceV2Layout from "./FinanceV2Layout";
import { NoteState } from "../../context/notes/NoteState";
import FinanceV2Services from "../../UserServices/FinanceV2Services";
import "./FinanceV2.css";

const ACTION_LABELS = {
  posted: "Journal posted",
  created: "Journal created",
  voided: "Journal voided",
  setup_completed: "Setup completed",
};

export default function FinanceV2AuditLog() {
  const { state } = useContext(NoteState);
  const { branch_id } = state;
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await FinanceV2Services.getAuditLog(branch_id);
      setRows(res.data?.data || []);
    } catch {
      toast.error("Could not load audit log");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [branch_id]);

  return (
    <FinanceV2Layout>
      <div className="fv2-page-header">
        <h1 className="fv2-page-title">Audit log</h1>
        <p className="fv2-page-sub text-muted">
          Track journal posts, voids, and setup changes — QuickBooks-style audit trail.
        </p>
      </div>

      <div className="card fv2-card">
        <div className="card-body p-0">
          {loading ? (
            <p className="p-4 text-muted mb-0">Loading audit log…</p>
          ) : rows.length === 0 ? (
            <p className="p-4 text-muted mb-0">No audit entries yet. Actions will appear here as you post journals.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover mb-0 fv2-table">
                <thead>
                  <tr>
                    <th>When</th>
                    <th>Action</th>
                    <th>Entity</th>
                    <th>Reference</th>
                    <th>User</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.id}>
                      <td className="text-nowrap">{new Date(row.created_at).toLocaleString()}</td>
                      <td>
                        <span className="badge bg-secondary">
                          {ACTION_LABELS[row.action] || row.action}
                        </span>
                      </td>
                      <td>
                        {row.entity_type}
                        {row.entity_id ? ` #${row.entity_id}` : ""}
                      </td>
                      <td>{row.after?.reference || row.before?.reference || "—"}</td>
                      <td>{row.user_name || "System"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </FinanceV2Layout>
  );
}
